var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultAppointType(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 230,
    viewBox: "0 0 230 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5415 123.864V148.541H196.458V123.864H33.5415ZM33.5415 19.1665H196.458C200.411 19.1665 203.795 20.5741 206.61 23.3892C209.426 26.2043 210.833 29.5884 210.833 33.5415V148.541C210.833 152.495 209.426 155.879 206.61 158.694C203.795 161.509 200.411 162.916 196.458 162.916H149.979V210.833L115 193.104L80.0207 210.833V162.916H33.5415C29.5884 162.916 26.2043 161.509 23.3892 158.694C20.5741 155.879 19.1665 152.495 19.1665 148.541V33.5415C19.1665 29.5884 20.5741 26.2043 23.3892 23.3892C26.2043 20.5741 29.5884 19.1665 33.5415 19.1665ZM33.5415 97.9894H196.458V33.5415H33.5415V97.9894Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAppointType);
export default __webpack_public_path__ + "static/media/DefaultAppointType.c24f924f85b4f79a644e54ac97667aa6.svg";
export { ForwardRef as ReactComponent };